export default "__VITE_ASSET__3f6cc975__"